<template>
  <nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul style="list-style: none">
      <li :class="{ topmenuactive: activeTab === 'hethongcntthochiminh' }" @click="changeTab('hethongcntthochiminh')">
        <a id="urlhethongcntthochiminh" href="vi/chuongtrinhtaitroxathidiem#hochiminh/hethongcntthochiminh"
          style="color: white;">{{ currentLanguage.header_text_hethongCNTT15 }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xabinhhung' }" @click="changeTab('Xabinhhung')">
        <a id="urlXabinhhung" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xabinhhung" style="color: white;">
          {{ currentLanguage.header_text_BinhHung }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xavinhloc' }" @click="changeTab('Xavinhloc')">
        <a id="urlXavinhloc" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xavinhloc" style="color: white;">
          {{ currentLanguage.header_text_VinhLoc }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xatanvinhloc' }" @click="changeTab('Xatanvinhloc')">
        <a id="urlXatanvinhloc" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xatanvinhloc" style="color: white;">
          {{ currentLanguage.header_text_TanVinhLoc }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xabinhloi' }" @click="changeTab('Xabinhloi')">
        <a id="urlXabinhloi" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xabinhloi" style="color: white;">
          {{ currentLanguage.header_text_BinhLoi }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xatannhut' }" @click="changeTab('Xatannhut')">
        <a id="urlXatannhut" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xatannhut" style="color: white;">
          {{ currentLanguage.header_text_TanNhut }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xabinhchan' }" @click="changeTab('Xabinhchan')">
        <a id="urlXabinhchan" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xabinhchan" style="color: white;">
          {{ currentLanguage.header_text_BinhChanh }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xahunglong' }" @click="changeTab('Xahunglong')">
        <a id="urlXahunglong" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xahunglong" style="color: white;">
          {{ currentLanguage.header_text_HungLong }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xacuchi' }" @click="changeTab('Xacuchi')">
        <a id="urlXacuchi" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xacuchi" style="color: white;">
          {{ currentLanguage.header_text_CuChi }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xaphuhoadong' }" @click="changeTab('Xaphuhoadong')">
        <a id="urlXaphuhoadong" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xaphuhoadong" style="color: white;">
          {{ currentLanguage.header_text_PhuHoaDong }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xabinhmy' }" @click="changeTab('Xabinhmy')">
        <a id="urlXabinhmy" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xabinhmy" style="color: white;">
          {{ currentLanguage.header_text_BinhMy }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xadongthanh' }" @click="changeTab('Xadongthanh')">
        <a id="urlXadongthanh" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xadongthanh" style="color: white;">
          {{ currentLanguage.header_text_DongThanh }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xahocmon' }" @click="changeTab('Xahocmon')">
        <a id="urlXahocmon" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xahocmon" style="color: white;">
          {{ currentLanguage.header_text_HocMon }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xaxuanthoison' }" @click="changeTab('Xaxuanthoison')">
        <a id="urlXaxuanthoison" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xaxuanthoison" style="color: white;">
          {{ currentLanguage.header_text_XuanThoiSon }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xabadiem' }" @click="changeTab('Xabadiem')">
        <a id="urlXabadiem" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xabadiem" style="color: white;">
          {{ currentLanguage.header_text_BaDiem }}
        </a>
      </li>

      <li :class="{ topmenuactive: activeTab === 'Xanhabe' }" @click="changeTab('Xanhabe')">
        <a id="urlXanhabe" href="vi/chuongtrinhtaitroxathidiem#hochiminh/xanhabe" style="color: white;">
          {{ currentLanguage.header_text_NhaBe }}
        </a>
      </li>
    </ul>
  </nav>

  <div class="wrapper row3">
        <main class="hoc container-fluid clear bv p-0">

      <!-- Mỗi xã -->
      <div v-if="activeTab === 'hethongcntthochiminh'" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleHtmlHethongcntthochiminh"></div>
        <div v-html="contentHtmlHethongcntthochiminh || 'Đang cập nhập...'"></div>
      </div>
      <div v-if="showXabinhhung" class="padding-top15">
        <div v-html="contentHtmlXabinhhung || 'Đang cập nhật...'"></div>
      </div>
      <div v-if="showXavinhloc" class="padding-top15">
        <div v-html="contentHtmlXavinhloc || 'Đang cập nhật...'"></div>
      </div>
      <div v-if="showXatanvinhloc" class="padding-top15">
        <div v-html="contentHtmlXatanvinhloc || 'Đang cập nhật...'"></div>
      </div>
      <div v-if="showXabinhloi" class="padding-top15">
        <div v-html="contentHtmlXabinhloi || 'Đang cập nhật...'"></div>
      </div>
      <div v-if="showXatannhut" class="padding-top15">
        <div v-html="contentHtmlXatannhut || 'Đang cập nhật...'"></div>
      </div>
      <div v-if="showXabinhchan" class="padding-top15">
        <div v-html="contentHtmlXabinhchan || 'Đang cập nhật...'"></div>
      </div>
      <div v-if="showXahunglong" class="padding-top15">
        <div v-html="contentHtmlXahunglong || 'Đang cập nhật...'"></div>
      </div>
      <div v-if="showXacuchi" class="padding-top15">
        <div v-html="contentHtmlXacuchi || 'Đang cập nhật...'"></div>
      </div>
      <div v-if="showXaphuhoadong" class="padding-top15">
        <div v-html="contentHtmlXaphuhoadong"></div>
      </div>
      <div v-if="showXabinhmy" class="padding-top15">
        <div v-html="contentHtmlXabinhmy"></div>
      </div>
      <div v-if="showXadongthanh" class="padding-top15">
        <div v-html="contentHtmlXadongthanh"></div>
      </div>
      <div v-if="showXahocmon" class="padding-top15">><div v-html="contentHtmlXahocmon"></div>
      </div>
      <div v-if="showXaxuanthoison" class="padding-top15">
        <div v-html="contentHtmlXaxuanthoison"></div>
      </div>
      <div v-if="showXabadiem" class="padding-top15">
        <div v-html="contentHtmlXabadiem"></div>
      </div>
      <div v-if="showXanhabe" class="padding-top15">
        <div v-html="contentHtmlXanhabe"></div>
      </div>
    </main>
  </div>
</template>

<script scoped>
import {
  languages
} from "@/components/languages";
import {
  apiChiTietBaiViet
} from "@/components/listService";
import axios from "axios";

export default {
  components: {

  },
  data() {
    return {
      activeTab: 'hethongcntthochiminh',

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      showXatanvinhloc: false,
      showXabinhloi: false,
      showXavinhloc: false,
      showCopilot: false,
      showGrok: false,
      showXatannhut: false,
      showManus: false,
      showXabinhhung: false,
      showXabinhchan: false,
      showXahunglong: false,
      showUngDungAI: false,
      showXacuchi: false,
      showXaphuhoadong: false,
      showXabinhmy: false,
      showXadongthanh: false,
      showXahocmon: false,
      showXaxuanthoison: false,
      showXabadiem: false,
      showXanhabe: false,
      showHethongcntthochiminh: false,

      titleHtmlAITaiLopHoc: "",
      contentHtmlAITaiLopHoc: "",
      titleHtml: "",
      contentHtml: "",
      titleHtmlTruongTaiTro: "",
      contentHtmlTruongTaiTro: "",
      titleHtmlTH: "",
      contentHtmlTH: "",
      titleHtmlTHCS: "",
      contentHtmlTHCS: "",
      titleHtmlTHPT: "",
      contentHtmlTHPT: "",
      titleHtmlLienHe: "",
      contentHtmlLienHe: "",
      titleHtmlLienCap: "",
      contentHtmlLienCap: "",

      titleHtmlXabinhhung: "",
      titleHtmlXatanvinhloc: "",
      titleHtmlXabinhloi: "",
      titleHtmlXavinhloc: "",
      titleHtmlCopilot: "",
      titleHtmlGrok: "",
      titleHtmlXatannhut: "",
      titleHtmlXabinhchan: "",
      titleHtmlXahunglong: "",
      titleHtmlManus: "",
      titleHtmlUngDungAI: "",
      titleHtmlXacuchi: "",
      titleHtmlXaphuhoadong: "",
      titleHtmlXabinhmy: "",
      titleHtmlXadongthanh: "",
      titleHtmlXahocmon: "",
      titleHtmlXaxuanthoison: "",
      titleHtmlXabadiem: "",
      titleHtmlXanhabe: "",
      titleHtmlHethongcntthochiminh: "",
      conttentHtmlHethongcntthochiminh: "",

      contentHtmlXabinhhung: "",
      contentHtmlXatanvinhloc: "",
      contentHtmlXabinhloi: "",
      contentHtmlCopilot: "",
      contentHtmlXavinhloc: "",
      contentHtmlGrok: "",
      contentHtmlXatannhut: "",
      contentHtmlXabinhchan: "",
      contentHtmlXahunglong: "",
      contentHtmlManus: "",
      contentHtmlUngDungAI: "",
      contentHtmlXacuchi: "",

      contentHtmlXaphuhoadong: "",
      contentHtmlXabinhmy: "",
      contentHtmlXadongthanh: "",
      contentHtmlXahocmon: "",
      contentHtmlXaxuanthoison: "",
      contentHtmlXabadiem: "",
      contentHtmlXanhabe: "",

    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.lang = localStorage.getItem("languages") || "vi";
      // this.performPostRequest("1755075075179y5bWE", "Xatanvinhloc", this.lang);
      document.getElementById("urlhethongcntthochiminh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/hethongcntt");
      document.getElementById("urlXabinhhung").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xabinhhung");
      document.getElementById("urlXavinhloc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xavinhloc");
      document.getElementById("urlXabinhloi").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xabinhloi");
      document.getElementById("urlXatanvinhloc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xatanvinhloc");
      document.getElementById("urlXatannhut").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xatannhut");
      document.getElementById("urlXabinhchan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xabinhchan");
      document.getElementById("urlXahunglong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xahunglong");
      document.getElementById("urlXacuchi").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xacuchi");
      document.getElementById("urlXaphuhoadong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xaphuhoadong");
      document.getElementById("urlXabinhmy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xabinhmy");
      document.getElementById("urlXadongthanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xadongthanh");
      document.getElementById("urlXahocmon").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xahocmon");
      document.getElementById("urlXaxuanthoison").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xaxuanthoison");
      document.getElementById("urlXabadiem").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xabadiem");
      document.getElementById("urlXanhabe").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/xanhabe");

      // document.getElementById("urlManus").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/manus/");
      // document.getElementById("urlGrok").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/grok/");
      // document.getElementById("urlCopilot").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hochiminh/copilot/");

      let fragmentTab = window.location.hash.substring(1);
      if (fragmentTab.endsWith("/")) {
        fragmentTab = fragmentTab.slice(0, -1);
      }
      console.log("fragmentTab " + fragmentTab);

      if (fragmentTab === "hochiminh/xabinhhung") {
        this.changeTab("Xabinhhung");
      } else if (fragmentTab === "hochiminh/xavinhloc") {
        this.changeTab("Xavinhloc");
      } else if (fragmentTab === "hochiminh/xabinhloi") {
        this.changeTab("Xabinhloi");
      } else if (fragmentTab === "hochiminh/xatanvinhloc") {
        this.changeTab("Xatanvinhloc");
      } else if (fragmentTab === "hochiminh/copilot") {
        this.changeTab("Copilot");
      } else if (fragmentTab === "hochiminh/grok") {
        this.changeTab("Grok");
      } else if (fragmentTab === "hochiminh/xatannhut") {
        this.changeTab("Xatannhut");
      } else if (fragmentTab === "hochiminh/manus") {
        this.changeTab("Manus");
      } else if (fragmentTab === "hochiminh/xabinhchan") {
        this.changeTab("Xabinhchan");
      } else if (fragmentTab === "hochiminh/xahunglong") {
        this.changeTab("Xahunglong");
      } else if (fragmentTab === "hochiminh/xacuchi") {
        this.changeTab("Xacuchi");
      } else if (fragmentTab === "hochiminh/xaphuhoadong") {
        this.changeTab("Xaphuhoadong");
      } else if (fragmentTab === "hochiminh/xabinhmy") {
        this.changeTab("Xabinhmy");
      } else if (fragmentTab === "hochiminh/xadongthanh") {
        this.changeTab("Xadongthanh");
      } else if (fragmentTab === "hochiminh/xahocmon") {
        this.changeTab("Xahocmon");
      } else if (fragmentTab === "hochiminh/xaxuanthoison") {
        this.changeTab("Xaxuanthoison");
      } else if (fragmentTab === "hochiminh/xabadiem") {
        this.changeTab("Xabadiem");
      } else if (fragmentTab === "hochiminh/xanhabe") {
        this.changeTab("Xanhabe");
      } else if (fragmentTab === "hochiminh/hethongcntthochiminh") {
        this.changeTab("hethongcntthochiminh");
      } else {
        // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
        this.changeTab("hethongcntthochiminh");
      }
    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store separately for each section
        if (section === "Xatanvinhloc") {
          this.titleHtmlXatanvinhloc = decodeURIComponent(escape(title));
          this.contentHtmlXatanvinhloc = decodeURIComponent(escape(decodedString));
        } else if (section === "Xabinhloi") {
          this.titleHtmlXabinhloi = decodeURIComponent(escape(title));
          this.contentHtmlXabinhloi = decodeURIComponent(escape(decodedString));
        } else if (section === "Xavinhloc") {
          this.titleHtmlXavinhloc = decodeURIComponent(escape(title));
          this.contentHtmlXavinhloc = decodeURIComponent(escape(decodedString));
        } else if (section === "Copilot") {
          this.titleHtmlCopilot = decodeURIComponent(escape(title));
          this.contentHtmlCopilot = decodeURIComponent(escape(decodedString));
        } else if (section === "Grok") {
          this.titleHtmlGrok = decodeURIComponent(escape(title));
          this.contentHtmlGrok = decodeURIComponent(escape(decodedString));
        } else if (section === "Xatannhut") {
          this.titleHtmlXatannhut = decodeURIComponent(escape(title));
          this.contentHtmlXatannhut = decodeURIComponent(escape(decodedString));
        } else if (section === "Manus") {
          this.titleHtmlManus = decodeURIComponent(escape(title));
          this.contentHtmlManus = decodeURIComponent(escape(decodedString));
        } else if (section === "Xabinhhung") {
          this.titleHtmlXabinhhung = decodeURIComponent(escape(title));
          this.contentHtmlXabinhhung = decodeURIComponent(escape(decodedString));
        } else if (section === "Xabinhchan") {
          this.titleHtmlXabinhchan = decodeURIComponent(escape(title));
          this.contentHtmlXabinhchan = decodeURIComponent(escape(decodedString));
        } else if (section === "Xahunglong") {
          this.titleHtmlXahunglong = decodeURIComponent(escape(title));
          this.contentHtmlXahunglong = decodeURIComponent(escape(decodedString));
        } else if (section === "UngDungAI") {
          this.titleHtmlUngDungAI = decodeURIComponent(escape(title));
          this.contentHtmlUngDungAI = decodeURIComponent(escape(decodedString));
        } else if (section === "Xacuchi") {
          this.titleHtmlXacuchi = decodeURIComponent(escape(title));
          this.contentHtmlXacuchi = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaphuhoadong") {
          this.titleHtmlXaphuhoadong = decodeURIComponent(escape(title));
          this.contentHtmlXaphuhoadong = decodeURIComponent(escape(decodedString));
        } else if (section === "Xabinhmy") {
          this.titleHtmlXabinhmy = decodeURIComponent(escape(title));
          this.contentHtmlXabinhmy = decodeURIComponent(escape(decodedString));
        } else if (section === "Xadongthanh") {
          this.titleHtmlXadongthanh = decodeURIComponent(escape(title));
          this.contentHtmlXadongthanh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xahocmon") {
          this.titleHtmlXahocmon = decodeURIComponent(escape(title));
          this.contentHtmlXahocmon = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaxuanthoison") {
          this.titleHtmlXaxuanthoison = decodeURIComponent(escape(title));
          this.contentHtmlXaxuanthoison = decodeURIComponent(escape(decodedString));
        } else if (section === "Xabadiem") {
          this.titleHtmlXabadiem = decodeURIComponent(escape(title));
          this.contentHtmlXabadiem = decodeURIComponent(escape(decodedString));
        } else if (section === "Xanhabe") {
          this.titleHtmlXanhabe = decodeURIComponent(escape(title));
          this.contentHtmlXanhabe = decodeURIComponent(escape(decodedString));
        } else if (section === "hethongcntthochiminh") {
          this.titleHtmlHethongcntthochiminh = decodeURIComponent(escape(title));
          this.contentHtmlHethongcntthochiminh = decodeURIComponent(escape(decodedString));

        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
      //   if (window.innerWidth <= 768) {
      //     this.isMenuVisible = false;
      //   }
      this.lang = localStorage.getItem("languages");

      const tabStates = {

        Xatanvinhloc: false,
        Xabinhloi: false,
        Xavinhloc: false,
        Copilot: false,
        ungDungAI: false,
        Xabinhhung: false,
        xatannhut: false,
        Grok: false,
        Manus: false,
        Xabinhchan: false,
        Xahunglong: false,
        Xacuchi: false,
        Xaphuhoadong: false,
        Xabinhmy: false,
        Xadongthanh: false,
        Xahocmon: false,
        Xaxuanthoison: false,
        Xabadiem: false,
        Xanhabe: false,
        hethongcntthochiminh: false,
      };

      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      tabStates[tab] = true;
      this.activeTab = tab;
      this.showXatanvinhloc = tabStates.Xatanvinhloc;
      this.showXabinhloi = tabStates.Xabinhloi;
      this.showXavinhloc = tabStates.Xavinhloc;
      this.showCopilot = tabStates.Copilot;
      this.showGrok = tabStates.Grok;
      this.showXatannhut = tabStates.Xatannhut;
      this.showManus = tabStates.Manus;
      this.showXabinhhung = tabStates.Xabinhhung;
      this.showXabinhchan = tabStates.Xabinhchan;
      this.showXahunglong = tabStates.Xahunglong;
      this.showUngDungAI = tabStates.UngDungAI;
      this.showXacuchi = tabStates.Xacuchi;
      this.showXaphuhoadong = tabStates.Xaphuhoadong;
      this.showXabinhmy = tabStates.Xabinhmy;
      this.showXadongthanh = tabStates.Xadongthanh;
      this.showXahocmon = tabStates.Xahocmon;
      this.showXaxuanthoison = tabStates.Xaxuanthoison;
      this.showXabadiem = tabStates.Xabadiem;

      this.showXanhabe = tabStates.Xanhabe;
      this.showHethongcntthochiminh = tabStates.hethongcntthochiminh;

    },
    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {

        Xatanvinhloc: "17579077526806tcx9",
        Xabinhloi: "1757907772550Ra1do",
        Xavinhloc: "17579077242877ZZNy",
        Copilot: "",
        Grok: "",
        Xatannhut: "1757907789787LYLQH",
        Manus: "",
        Xabinhhung: "1757907696564KLBw6",
        Xabinhchan: "1757907835082AWRTa", // thay ID sau
        Xahunglong: "1757907850669Amsl6", // thay ID sau  
        UngDungAI: "", // thay ID sau
        Xacuchi: "1757907865824SXQbx", // thay ID sau
        Xaphuhoadong: "1757907885697L3ThH", // thay ID sau
        Xabinhmy: "1757907901268hRE3F", // thay ID sau
        Xadongthanh: "1757907938784gffLy", //
        Xahocmon: "1757907977003tAx4q", // thay ID sau
        Xaxuanthoison: "1757908008691JCvH4", //
        Xabadiem: "1757908035384wyMX4", // thay ID sau
        Xanhabe: "1757908300478dxnRU", // thay ID sau
        hethongcntthochiminh: "1757648306376u0tg0",
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
.title-bai-viet {
  display: none;
}

.hiddentitle {
  display: none;
}
</style>
